import { QuestionOutline } from '@assets/svg';
import Flex from '@components/Flex/Flex';
import IconButton from '@components/IconButton/IconButton';
import Text from '@components/Text/Text';
import { Tooltip, useTheme } from '@mui/material';
import { TextToolTipProps } from './TextToolTip.types';

const TextToolTip: React.FC<TextToolTipProps> = ({
  text,
  toolTipText,
  toolTipProps,
  textProps,
  icon: Icon = QuestionOutline,
}) => {
  const theme = useTheme();
  return (
    <Flex alignItems='center'>
      <Text
        variant='h6'
        fontWeight='fontWeightSemiBold'
        color={theme.palette.black.A100}
        {...textProps}
      >
        {text}
      </Text>
      <Tooltip
        title={toolTipText}
        placement='top'
        enterTouchDelay={0}
        componentsProps={{
          tooltip: {
            sx: {
              bgcolor: theme.palette.primary[100],
              color: theme.palette.primary.main,
              padding: theme.spacing(5),
              textAlign: 'center',
              border: `1px solid ${theme.palette.primary.main}`,
            },
          },
        }}
        {...toolTipProps}
      >
        <span>
          <IconButton
            data-testid='text-tool-tip-button'
            size='small'
            iconBoxHeight={25}
            iconBoxWidth={25}
            icon={() => <Icon color={theme.palette.primary.main} />}
          />
        </span>
      </Tooltip>
    </Flex>
  );
};

export default TextToolTip;
